import React from 'react'
import styled from 'styled-components'
import BookSourceSection from './common/BookSourceSection'
import RowSpacer from '../../../../common/styles/RowSpacer'
import ContentContainer from '../../../../common/styles/ContentContainer'
import ColSpacer from '../../../../common/styles/ColSpacer'
import { SearchBookSourceUsedOfflineResponse } from '../SearchBookSourceUsedResponse'
import useBookUsedOffline from '../hooks/useBookUsedOffline'
import utils from '../../../../common/utils'
import BookSourceNoContent from '../BookSourceNoContent'
import BookSourceSectionLoading from './common/BookSourceSectionLoading'

interface Props {
	isbn: string
}

const BookSourceOfflineUsedSection: React.FC<Props> = ({ isbn }) => {
	const [usedOffline, isUsedOfflineLoading] = useBookUsedOffline(isbn ?? '')

	return (
		<BookSourceSection
			title={`중고 (매장)`}
			isEmpty={isUsedOfflineLoading ? false : usedOffline.length === 0}
			// @ts-ignore
			body={isUsedOfflineLoading || usedOffline == null ? <BookSourceSectionLoading /> : <Body offlineUsed={usedOffline} />}
		/>
	)
}

interface BodyProps {
	offlineUsed: SearchBookSourceUsedOfflineResponse[]
}

const Body: React.FC<BodyProps> = ({ offlineUsed }) => {
	if (offlineUsed.length === 0) {
		return <BookSourceNoContent message={'중고 (매장)에는 책이 없어요'} />
	}

	return (
		<>
			{offlineUsed.map(used => {
				return (
					<div className={'hover-effect'}>
						<a href={used.link!!} target={'_blank'} rel="noreferrer">
							<RowSpacer size={10} />
							<ContentContainer>
								<div style={{ flex: 1 }}>
									<Row>
										<span className={'d-flex'}>
											<Icon src={used.imageUrl} />

											<ColSpacer size={5} />

											<div>
												<h6 className={'p-0 m-0 pt-1'} style={{ color: 'var(--text-color)' }}>
													{used.label}
												</h6>
												<Info>최저 {utils.insertCommas(used.minPrice)}원</Info>
												<Info>총 {used.stockCount}권</Info>
											</div>
										</span>

										<LocationBadgeList>
											{Array.from({ length: Math.ceil(used.locationList.length / 5) }, (_, rowIndex) => (
												<LocationBadgeRow key={rowIndex}>
													{used.locationList.slice(rowIndex * 5, rowIndex * 5 + 5).map((loc, i) => (
														<LocationBadge key={i}>{loc}</LocationBadge>
													))}
												</LocationBadgeRow>
											))}
										</LocationBadgeList>
									</Row>
								</div>
							</ContentContainer>
						</a>
					</div>
				)
			})}
		</>
	)
}

const Row = styled.span`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	width: 100%;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`

const Icon = styled.img.attrs({
	className: 'rounded',
})`
	width: 30px;
	height: 30px;
`

const LocationBadgeList = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 4px;
	margin-left: auto;

	@media (max-width: 768px) {
		flex-direction: row;
		flex-wrap: wrap;
		align-items: flex-start;
		margin-left: 0;
		padding-top: 8px;
	}
`

const LocationBadgeRow = styled.div`
	display: flex;
	gap: 4px;

	@media (max-width: 768px) {
		display: contents;
	}
`

const LocationBadge = styled.span`
	background-color: var(--badge-bg-color);
	color: white;
	font-size: 0.75rem;
	font-weight: bold;
	border-radius: 5px;
	padding: 2px 8px;
`

const Info = styled.h6`
	font-size: 0.9rem;
	padding: 0 0 0 20px;
	margin: 0;
	color: var(--sub-text-color);
`

export default BookSourceOfflineUsedSection
